module.exports = __webpack_public_path__ + "eef5d713e8f4570f39c49a28310c5861.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/charts/qualcomm_2022_chart.png
// module id = 1714
// module chunks = 0